import Link from "next/link";
import {
  Box,
  Container,
  Flex,
  Grid,
  GridItem,
  HStack,
  Icon,
  Text,
  VStack,
} from "@chakra-ui/react";
import { Scissors } from "lucide-react";
import { FaInstagram, FaWhatsapp } from "react-icons/fa";
import { FOOTER_GROUPS } from "./homeContent";

export function HomeFooter() {
  return (
    <Box as="footer" bg="barber.900" py={12} borderTop="1px solid" borderColor="whiteAlpha.100">
      <Container maxW="container.xl">
        <Grid
          templateColumns={{ base: "1fr", md: "repeat(2, 1fr)", lg: "repeat(4, 1fr)" }}
          gap={8}
          mb={8}
        >
          <GridItem>
            <VStack align="start" spacing={4}>
              <HStack spacing={2}>
                <Scissors size={24} color="#fba931" />
                <Text fontSize="xl" fontWeight="bold" color="white">
                  Meu Barbeiro Pro
                </Text>
              </HStack>
              <Text fontSize="sm" color="barber.100">
                Sistema para barbearia com agenda online, clientes, equipe e
                gestão em um só lugar.
              </Text>
            </VStack>
          </GridItem>

          <GridItem>
            <VStack align="start" spacing={4}>
              <Text fontWeight="bold" color="white">
                Produto
              </Text>
              <VStack align="start" spacing={2}>
                {FOOTER_GROUPS.produto.map((link) => (
                  <Link key={link.href} href={link.href}>
                    <Text fontSize="sm" color="barber.100" _hover={{ color: "orange.900" }}>
                      {link.label}
                    </Text>
                  </Link>
                ))}
              </VStack>
            </VStack>
          </GridItem>

          <GridItem>
            <VStack align="start" spacing={4}>
              <Text fontWeight="bold" color="white">
                Suporte
              </Text>
              <VStack align="start" spacing={2}>
                {FOOTER_GROUPS.suporte.map((link) => (
                  <Link key={link.href} href={link.href}>
                    <Text fontSize="sm" color="barber.100" _hover={{ color: "orange.900" }}>
                      {link.label}
                    </Text>
                  </Link>
                ))}
              </VStack>
            </VStack>
          </GridItem>

          <GridItem>
            <VStack align="start" spacing={4}>
              <Text fontWeight="bold" color="white">
                Legal
              </Text>
              <VStack align="start" spacing={2}>
                {FOOTER_GROUPS.legal.map((link) => (
                  <Link key={link.href} href={link.href}>
                    <Text fontSize="sm" color="barber.100" _hover={{ color: "orange.900" }}>
                      {link.label}
                    </Text>
                  </Link>
                ))}
              </VStack>
            </VStack>
          </GridItem>
        </Grid>

        <Box borderTop="1px" borderColor="barber.100" pt={8}>
          <Flex
            direction={{ base: "column", md: "row" }}
            justify="space-between"
            align="center"
            gap={4}
          >
            <Text fontSize="sm" color="barber.100">
              &copy; {new Date().getFullYear()} Meu Barbeiro Pro. Todos os direitos
              reservados.
            </Text>
            <HStack spacing={4}>
              <Link href="https://www.instagram.com/meubarbeiropro_?utm_source=ig_web_button_share_sheet&igsi=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer">
                <Box color="barber.100" _hover={{ color: "orange.900" }}>
                  <Icon as={FaInstagram} boxSize={5} />
                </Box>
              </Link>
              <Link href="https://wa.me/5585994176634" target="_blank" rel="noopener noreferrer">
                <Box color="barber.100" _hover={{ color: "orange.900" }}>
                  <Icon as={FaWhatsapp} boxSize={5} />
                </Box>
              </Link>
            </HStack>
          </Flex>
        </Box>
      </Container>
    </Box>
  );
}
